import {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import DeleteAccountModal from './DeleteAccountModal';
import {useToast} from './Toast';
import {isAuthError} from '../api';

export default function AccountSettingsPage({username, onDeleteAccount, onBack}) {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const showToast = useToast();

    const handleDelete = useCallback(async () => {
        try {
            await onDeleteAccount();
        } catch (err) {
            setShowDeleteModal(false);
            if (!isAuthError(err)) showToast(err.message);
        }
    }, [onDeleteAccount, showToast]);

    return (
        <div className="settings-page">
            <div className="settings-container">
                <div className="settings-header">
                    <button className="settings-back" onClick={onBack}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M9 2L4 7L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Back
                    </button>
                    <h1 className="settings-title">Account settings</h1>
                </div>

                <div className="settings-section">
                    <h2 className="settings-section-title">Profile</h2>
                    <div className="settings-row">
                        <span className="settings-row-label">Username</span>
                        <span className="settings-row-value">{username}</span>
                    </div>
                </div>

                <div className="settings-section settings-section--danger">
                    <h2 className="settings-section-title settings-section-title--danger">Danger zone</h2>
                    <div className="settings-danger-row">
                        <div className="settings-danger-info">
                            <span className="settings-danger-label">Delete account</span>
                            <span className="settings-danger-desc">Permanently remove your account and all checklists. This cannot be undone.</span>
                        </div>
                        <button className="settings-danger-button" onClick={() => setShowDeleteModal(true)}>
                            Delete account
                        </button>
                    </div>
                </div>
            </div>

            {showDeleteModal && (
                <DeleteAccountModal
                    onConfirm={handleDelete}
                    onCancel={() => setShowDeleteModal(false)}
                />
            )}
        </div>
    );
}

AccountSettingsPage.propTypes = {
    username: PropTypes.string.isRequired,
    onDeleteAccount: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
};
